// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3afK9","label":"styles_label__icX4v"};